import LangEnum from '../../../../../../../lang/LangEnum';
import { AvailabilityEnum } from '../../../../../../products/ProductTypes';
import { OfflineOrderProduct } from '../../../orderProduct/OfflineOrderProduct';
import {
  OfflineOrderRulesReturnMap,
  OfflineOrderRulesTo,
  ValidateOfflineOrderRuleParams,
} from '../../OfflineOrderRules.types';
import BaseOrderProductQuantityRule from '../baseOrderProductQuantity.rule';

export default class ReadyForDeliveryMinimumAmountByProductRule extends BaseOrderProductQuantityRule {
  validate({
    order,
    userRole,
  }: ValidateOfflineOrderRuleParams): OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_PRODUCTS] {
    if (this.canUserBypassRule(userRole)) {
      return { hasErrors: false };
    }

    const filtered = this.filterOrderProducts(order.products ?? []);
    const grouped = this.groupOrderProductsByProductId(filtered);

    Object.values(grouped).forEach((orderProducts) => {
      if (orderProducts.length) {
        this.validateOrderProducts(orderProducts);
      }
    });

    if (!this.orderProductsWithError.length) {
      return {
        hasErrors: false,
      };
    }

    return {
      hasErrors: true,
      error: {
        messageCode: LangEnum.ORDER_PRODUCT_RULE_READY_FOR_DELIVERY_MINIMUM_AMOUNT_BY_PRODUCT,
      },
      orderProductsWithError: this.orderProductsWithError,
    };
  }

  private filterOrderProducts(products: OfflineOrderProduct[]): OfflineOrderProduct[] {
    return products.filter(
      (orderProduct) =>
        orderProduct.availability === AvailabilityEnum.READY_FOR_DELIVERY &&
        !!orderProduct.product.rules?.readyForDeliveryMinimumProduct,
    );
  }

  private validateOrderProducts(orderProducts: OfflineOrderProduct[]) {
    const achievedQuantity = this.getOrderProductsTotalQuantity(orderProducts);
    const minimumQuantity = orderProducts[0].product.rules?.readyForDeliveryMinimumProduct ?? 0;

    if (achievedQuantity < minimumQuantity) {
      this.pushAllProductsWithError(orderProducts, {
        achievedQuantity,
        minimumQuantity,
      });
    }
  }
}
